module.exports = __webpack_public_path__ + "img/symbol_14_normal.ced00d73.png";